import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CookieService } from 'ngx-cookie-service';
import { environment } from "../../../../environments/environment";
import { ProviderGroupSpot, ProviderGroupSpotDto } from '../../models/provider-parking/provider-group-spot.model';

@Injectable({
    providedIn: 'root',
})
export class MapperProviderGroupService {
    private baseUrl = environment.apiPrivateUrl;

    constructor(
        private cookieService: CookieService,
    ) { }   /** 
     * Map Data From API (DTO) to Logical Model (ProviderGroup) 
     */
    public mapProviderGroupFromDto(dto: ProviderGroupSpotDto): ProviderGroupSpot {
        return {
            id: dto.Id || 0,
            name: dto.GroupName || '',
            servicePoints: dto.Points || [],
            site: dto.SiteCode || ''
        };
    }

    /** 
     * Map Logical Model (ProviderGroup) back to API (DTO) 
     */
    public mapProviderGroupToDto(model: ProviderGroupSpot): ProviderGroupSpotDto {
        return {
            Id: model.id,
            GroupName: model.name,
            Points: model.servicePoints,
            SiteCode: model.site
        };
    }
}